<template>
    <div>
        <sav-fold-card :title="data.product.libelle || data.product.model" v-model="open">
            <template v-slot:open>
                <!-- Ean -->
                <template v-if="data.product && data.product.ean">
                    <hr class="mt-3">
                    <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.ean')}}</h6>
                    <span class="text-gray-600 break-words"> {{ data.product.ean }} </span>
                </template>
                <!-- Numéro série -->
                <template v-if="data.product && data.product.num_serie && data.product.num_serie != 'null'">
                    <hr class="mt-3">
                    <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.numero_de_serie')}}</h6>
                    <span class="text-gray-600 break-words"> {{ data.product.num_serie }} </span>
                </template>
                <!-- Vendeur -->
                <template v-if="data.shop && data.shop.name">
                    <hr class="mt-3">
                    <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.vendeur')}}</h6>
                    <span class="text-gray-600 break-words"> {{ data.shop.name + ' - ' + data.shop.fullAddress }} </span>
                </template>
                <!-- Date Achat -->
                <template v-if="isValidDate(data.date_ha)">
                    <hr class="mt-3">
                    <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.date_achat')}}</h6>
                    <span class="text-gray-600 break-words"> {{ data.date_ha | moment }} </span>
                </template>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props: {
        data: {
            required: true
        }
    },
    data() {
        return {
            open: false
        }
    },
    methods: {
        isValidDate(date) {
            var date = moment(date);
            return date.isValid()
        }
    },
    filters: {
        moment(date) {
            return moment(date).format('DD/MM/YYYY');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/ProductCard.vue